import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import { ApplicationType, Application } from '../types/application'
import {
  applicationQueryArgs,
  ApplicationQueryArgs
} from '../types/application-query-args'
import { findByIDAndOrganizationID } from './helpers/application'

export const application: GraphQLFieldConfig<
  any,
  Context,
  ApplicationQueryArgs
> = {
  description: 'Get an application by ID and Organization ID',
  type: new GraphQLNonNull(ApplicationType),
  args: applicationQueryArgs,
  resolve(_source, args, context): Promise<Partial<Application>> {
    const { organizationID, applicationID } = args

    return findByIDAndOrganizationID(
      applicationID,
      organizationID,
      context.connector
    )
  }
}
